import { render, staticRenderFns } from "./NewsAndNoticeEdit.vue?vue&type=template&id=57ca630d&"
import script from "./NewsAndNoticeEdit.vue?vue&type=script&lang=js&"
export * from "./NewsAndNoticeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports